import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Loader2, MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiErrorDetail } from "@/lib/api";
import AuthShell from "@/pages/auth/AuthShell";

export default function ForgotPassword() {
  const { t, i18n } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, lang: i18n.language });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t("forgot.title")} subtitle={t("forgot.subtitle")} testid="forgot-page"
      footer={<Link to="/login" className="font-semibold text-cyan-dark hover:underline">{t("forgot.back")}</Link>}>
      {sent ? (
        <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-5 text-center" data-testid="forgot-success">
          <MailCheck className="mx-auto h-8 w-8 text-emerald-600" />
          <p className="mt-3 text-sm text-slate-600">{t("forgot.success", { email })}</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5">
          <div className="space-y-2">
            <Label htmlFor="email">{t("forgot.email")}</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
          </div>
          {error && <div className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600">{error}</div>}
          <Button type="submit" disabled={loading} data-testid="forgot-submit-button" className="w-full rounded-full bg-navy text-white hover:bg-navy-muted">
            {loading ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> {t("forgot.sending")}</> : t("forgot.submit")}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
